var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import styled from "styled-components";
import { MenuItem } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import DeletePollMutation from "@irati/recognition/apollo/mutation/Poll/Delete";
import MenuActionsBase from "../../../shared/MenuActions";
import Wrapper from "../../shared/Poll/Wrapper";
import ConfirmDeletePoll from "../../shared/Poll/ConfirmDeletePoll";
var MenuActions = styled(MenuActionsBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var OpenPollActions = /** @class */ (function (_super) {
    __extends(OpenPollActions, _super);
    function OpenPollActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDeleteMode: false
        };
        _this.enableDeleteMode = function () {
            _this.setState({
                isDeleteMode: true
            });
        };
        _this.disableDeleteMode = function () {
            _this.setState({
                isDeleteMode: false
            });
        };
        return _this;
    }
    OpenPollActions.prototype.render = function () {
        var _this = this;
        var _a = this.props, poll = _a.poll, onDeleteSuccess = _a.onDeleteSuccess, props = __rest(_a, ["poll", "onDeleteSuccess"]);
        var isDeleteMode = this.state.isDeleteMode;
        return (React.createElement(React.Fragment, null,
            React.createElement(MenuActions, __assign({ pullRight: true, item: poll }, props, { disabled: isDeleteMode }), function (_a) {
                var isUserContent = _a.isUserContent, canDeletePoll = _a.canDeletePoll, isAdmin = _a.isAdmin;
                return ([
                    ((poll.active && !poll.archived && isUserContent && canDeletePoll) || isAdmin) && (React.createElement(MenuItem, { key: 1, onSelect: _this.enableDeleteMode },
                        React.createElement(FormattedMessage, { id: "recognition.polls.openPoll.poll.btnDelete.label" })))
                ]);
            }),
            React.createElement(Wrapper, null, isDeleteMode &&
                React.createElement(DeletePollMutation, { poll: poll, onCompleted: onDeleteSuccess }, function (mutate, apolloState) { return (React.createElement(ConfirmDeletePoll, { poll: poll, apolloState: apolloState, onCancel: _this.disableDeleteMode, onConfirm: mutate })); }))));
    };
    return OpenPollActions;
}(Component));
export default OpenPollActions;
var templateObject_1;
